/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ReportPermission } from './ReportPermission';
import {
    ReportPermissionFromJSON,
    ReportPermissionFromJSONTyped,
    ReportPermissionToJSON,
} from './ReportPermission';
import type { UserPriority } from './UserPriority';
import {
    UserPriorityFromJSON,
    UserPriorityFromJSONTyped,
    UserPriorityToJSON,
} from './UserPriority';

/**
 * 
 * @export
 * @interface UserSetting
 */
export interface UserSetting {
    /**
     * Time stamp method
     * @type {string}
     * @memberof UserSetting
     */
    providerTimeStampMethod?: UserSettingProviderTimeStampMethodEnum;
    /**
     * Clock Sync Interval in seconds.
     * @type {number}
     * @memberof UserSetting
     */
    clockSyncInterval?: number;
    /**
     * Downsample Interval in seconds.
     * @type {number}
     * @memberof UserSetting
     */
    downSampleInterval?: number;
    /**
     * Add timestamp to messages.
     * @type {boolean}
     * @memberof UserSetting
     */
    useTimestamp?: boolean;
    /**
     * User Type
     * @type {string}
     * @memberof UserSetting
     */
    userType?: UserSettingUserTypeEnum;
    /**
     * Forward Cached Static Voyage Data
     * @type {boolean}
     * @memberof UserSetting
     */
    fwdCachedVoydata?: boolean;
    /**
     * LSS Group
     * @type {string}
     * @memberof UserSetting
     */
    lssGroup?: string;
    /**
     * 
     * @type {UserPriority}
     * @memberof UserSetting
     */
    userPriority?: UserPriority;
    /**
     * Receive system status updates
     * @type {boolean}
     * @memberof UserSetting
     */
    receiveSystemStatus?: boolean;
    /**
     * If true, user will receive GAD-specific proprietary messages
     * @type {boolean}
     * @memberof UserSetting
     */
    hasGad?: boolean;
    /**
     * When congestion occurs the downsampling interval is adjusted by this amount (seconds).
     * @type {number}
     * @memberof UserSetting
     */
    congestionDownsamplingAdjustment?: number;
    /**
     * The maximum adjustment.
     * @type {number}
     * @memberof UserSetting
     */
    maxCongestionDownsamplingAdjustment?: number;
    /**
     * Time between congestion adjustments (seconds)
     * @type {number}
     * @memberof UserSetting
     */
    timeBetweenCongestionAdjustments?: number;
    /**
     * Output Format
     * @type {string}
     * @memberof UserSetting
     */
    outputFormat?: UserSettingOutputFormatEnum;
    /**
     * Region Mask
     * @type {string}
     * @memberof UserSetting
     */
    regionMask?: string;
    /**
     * Include External ID
     * @type {boolean}
     * @memberof UserSetting
     */
    incExtId?: boolean;
    /**
     * Include PEEP sentences
     * @type {boolean}
     * @memberof UserSetting
     */
    incPeep?: boolean;
    /**
     * Maximum message rate (msg/sec)
     * @type {number}
     * @memberof UserSetting
     */
    maxMsgRate?: number;
    /**
     * Fixed downsampling interval (seconds)
     * @type {number}
     * @memberof UserSetting
     */
    fixedDsInterval?: number;
    /**
     * Default MMSI number
     * @type {number}
     * @memberof UserSetting
     */
    defaultMmsiNumber?: number;
    /**
     * List of MMSI numbers
     * @type {Array<number>}
     * @memberof UserSetting
     */
    mmsiList?: Array<number>;
    /**
     * Default PSS transmission list
     * @type {Array<string>}
     * @memberof UserSetting
     */
    defaultPssTxList?: Array<string>;
    /**
     * Allowed PSS transmission list
     * @type {Array<string>}
     * @memberof UserSetting
     */
    allowedPssTxList?: Array<string>;
    /**
     * 
     * @type {UserPriority}
     * @memberof UserSetting
     */
    reportPriority?: UserPriority;
    /**
     * Permissions for viewing/running reports
     * @type {Array<ReportPermission>}
     * @memberof UserSetting
     */
    reportPermissions?: Array<ReportPermission>;
    /**
     * If true, allow all report types.
     * @type {boolean}
     * @memberof UserSetting
     */
    reportPermissionsAllowAll?: boolean;
}


/**
 * @export
 */
export const UserSettingProviderTimeStampMethodEnum = {
    None: 'none',
    BsNone: 'bs_none',
    BsServer: 'bs_server',
    Server: 'server'
} as const;
export type UserSettingProviderTimeStampMethodEnum = typeof UserSettingProviderTimeStampMethodEnum[keyof typeof UserSettingProviderTimeStampMethodEnum];

/**
 * @export
 */
export const UserSettingUserTypeEnum = {
    Subscriber: 'Subscriber',
    Provider: 'Provider'
} as const;
export type UserSettingUserTypeEnum = typeof UserSettingUserTypeEnum[keyof typeof UserSettingUserTypeEnum];

/**
 * @export
 */
export const UserSettingOutputFormatEnum = {
    Default: 'default',
    OthGold: 'oth_gold',
    NmeaPghp1: 'nmea_pghp1',
    NmeaCommentBlock: 'nmea_comment_block',
    NmeaTag: 'nmea_tag',
    NmeaUnixTs: 'nmea_unix_ts',
    GhXml: 'gh_xml',
    NmeaTagSsn: 'nmea_tag_ssn',
    NmeaTagSsnNoPss: 'nmea_tag_ssn_no_pss'
} as const;
export type UserSettingOutputFormatEnum = typeof UserSettingOutputFormatEnum[keyof typeof UserSettingOutputFormatEnum];


/**
 * Check if a given object implements the UserSetting interface.
 */
export function instanceOfUserSetting(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserSettingFromJSON(json: any): UserSetting {
    return UserSettingFromJSONTyped(json, false);
}

export function UserSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserSetting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'providerTimeStampMethod': !exists(json, 'provider_time_stamp_method') ? undefined : json['provider_time_stamp_method'],
        'clockSyncInterval': !exists(json, 'clock_sync_interval') ? undefined : json['clock_sync_interval'],
        'downSampleInterval': !exists(json, 'down_sample_interval') ? undefined : json['down_sample_interval'],
        'useTimestamp': !exists(json, 'use_timestamp') ? undefined : json['use_timestamp'],
        'userType': !exists(json, 'user_type') ? undefined : json['user_type'],
        'fwdCachedVoydata': !exists(json, 'fwd_cached_voydata') ? undefined : json['fwd_cached_voydata'],
        'lssGroup': !exists(json, 'lss_group') ? undefined : json['lss_group'],
        'userPriority': !exists(json, 'user_priority') ? undefined : UserPriorityFromJSON(json['user_priority']),
        'receiveSystemStatus': !exists(json, 'receive_system_status') ? undefined : json['receive_system_status'],
        'hasGad': !exists(json, 'has_gad') ? undefined : json['has_gad'],
        'congestionDownsamplingAdjustment': !exists(json, 'congestion_downsampling_adjustment') ? undefined : json['congestion_downsampling_adjustment'],
        'maxCongestionDownsamplingAdjustment': !exists(json, 'max_congestion_downsampling_adjustment') ? undefined : json['max_congestion_downsampling_adjustment'],
        'timeBetweenCongestionAdjustments': !exists(json, 'time_between_congestion_adjustments') ? undefined : json['time_between_congestion_adjustments'],
        'outputFormat': !exists(json, 'output_format') ? undefined : json['output_format'],
        'regionMask': !exists(json, 'region_mask') ? undefined : json['region_mask'],
        'incExtId': !exists(json, 'inc_ext_id') ? undefined : json['inc_ext_id'],
        'incPeep': !exists(json, 'inc_peep') ? undefined : json['inc_peep'],
        'maxMsgRate': !exists(json, 'max_msg_rate') ? undefined : json['max_msg_rate'],
        'fixedDsInterval': !exists(json, 'fixed_ds_interval') ? undefined : json['fixed_ds_interval'],
        'defaultMmsiNumber': !exists(json, 'default_mmsi_number') ? undefined : json['default_mmsi_number'],
        'mmsiList': !exists(json, 'mmsi_list') ? undefined : json['mmsi_list'],
        'defaultPssTxList': !exists(json, 'default_pss_tx_list') ? undefined : json['default_pss_tx_list'],
        'allowedPssTxList': !exists(json, 'allowed_pss_tx_list') ? undefined : json['allowed_pss_tx_list'],
        'reportPriority': !exists(json, 'report_priority') ? undefined : UserPriorityFromJSON(json['report_priority']),
        'reportPermissions': !exists(json, 'report_permissions') ? undefined : ((json['report_permissions'] as Array<any>).map(ReportPermissionFromJSON)),
        'reportPermissionsAllowAll': !exists(json, 'report_permissions_allow_all') ? undefined : json['report_permissions_allow_all'],
    };
}

export function UserSettingToJSON(value?: UserSetting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'provider_time_stamp_method': value.providerTimeStampMethod,
        'clock_sync_interval': value.clockSyncInterval,
        'down_sample_interval': value.downSampleInterval,
        'use_timestamp': value.useTimestamp,
        'user_type': value.userType,
        'fwd_cached_voydata': value.fwdCachedVoydata,
        'lss_group': value.lssGroup,
        'user_priority': UserPriorityToJSON(value.userPriority),
        'receive_system_status': value.receiveSystemStatus,
        'has_gad': value.hasGad,
        'congestion_downsampling_adjustment': value.congestionDownsamplingAdjustment,
        'max_congestion_downsampling_adjustment': value.maxCongestionDownsamplingAdjustment,
        'time_between_congestion_adjustments': value.timeBetweenCongestionAdjustments,
        'output_format': value.outputFormat,
        'region_mask': value.regionMask,
        'inc_ext_id': value.incExtId,
        'inc_peep': value.incPeep,
        'max_msg_rate': value.maxMsgRate,
        'fixed_ds_interval': value.fixedDsInterval,
        'default_mmsi_number': value.defaultMmsiNumber,
        'mmsi_list': value.mmsiList,
        'default_pss_tx_list': value.defaultPssTxList,
        'allowed_pss_tx_list': value.allowedPssTxList,
        'report_priority': UserPriorityToJSON(value.reportPriority),
        'report_permissions': value.reportPermissions === undefined ? undefined : ((value.reportPermissions as Array<any>).map(ReportPermissionToJSON)),
        'report_permissions_allow_all': value.reportPermissionsAllowAll,
    };
}

